import React from 'react';
import UserStatsBox from '../UserStatsBox';
import { useUserStats } from '../../hooks/useUserStats';
import { useAuctionState } from '../../hooks/useAuctionState';
import { useContext } from 'react';
import { AuctionContext } from '../../context/AuctionContext';
import { useContribution } from '../../context/ContributionContext';

/**
 * User Stats Section component
 * Displays user statistics including contributions and JINU allocations
 */
const UserStatsSection = () => {
  const { 
    userStats = {}, 
    hasConfirmedContributions = false, 
    hasProjectedContributions = false
  } = useUserStats();
  
  const { auctionState = {}, currentDay = 1 } = useAuctionState();
  const { stats = {} } = useContext(AuctionContext);
  const { userContributions = {} } = useContribution();
  
  // Make sure we have the correct values for JINU allocations
  const totalUserJinu = stats.confirmedJinu || userStats.confirmedJinu || 0;
  const pendingJinu = stats.pendingJinu || userStats.pendingJinu || 0;
  
  return (
    <UserStatsBox
      userContribution={userStats.totalContribution || 0}
      pendingContribution={userStats.pendingContribution || 0}
      totalUserJinu={totalUserJinu}
      pendingJinu={pendingJinu}
      dailyAllocations={auctionState.dailyAllocations || []}
      completedSocialTasks={[]} // This could be enhanced in the future
      currentDay={currentDay}
      hasConfirmedContributions={hasConfirmedContributions}
      hasProjectedContributions={hasProjectedContributions}
      userContributions={userContributions}
    />
  );
};

export default UserStatsSection;
